import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Label, Input, FormGroup, Modal, ModalBody, ModalFooter} from 'reactstrap';
import {apiRequest} from "../../utils/request";
import {throttle} from 'lodash';

class ExistingClientLocaion extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      exists: false,
      like: false,
    };

    this.checkExisting = this.checkExisting.bind(this);
    this.throttledCheckExisting = throttle(this.checkExisting, 1000);
  }

  checkExisting(name, mode) {
    apiRequest(`/api/${mode}s/exact?name=${name}`)
      .then(x => {
        if (x.data) {
          this.setState({
            exists: x.data.exists,
            like: x.data.like,
          });
        }
      });
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    let {name, mode} = this.props;

    if (name !== prevProps.name && name !== null && name.length > 1) {
      this.throttledCheckExisting(name, mode);
    }
  }

  render() {
    let {exists, like} = this.state;
    let {name} = this.props;

    return name && name.length > 1 ? (<div>
      {(like && !exists) && <div className="alert alert-warning" role="alert">
        <i className={'fa fa-exclamation-triangle'}/>&nbsp;This name is similar to an existing name
      </div>}
      {(exists) && <div className="alert alert-danger" role="alert">
        <i className={'fa fa-cross'}/>&nbsp;This name is already in use
      </div>}
      {(!like && !exists) && <div className="alert alert-success" role="alert">
        This name doesn't appear to be taken
      </div>}
    </div>) : null;
  }
}

ExistingClientLocaion.propTypes = {
  mode: PropTypes.oneOf(['location', 'client']),
  name: PropTypes.string.isRequired,
};

export default ExistingClientLocaion;